<template>
  <common-dialog ref="dialog" :title="title" width="300px" :modal="true" :in-dialog="inDialog">
    <div>
      <el-form ref="form" label-width="90px">
        <el-row>
          <el-col :span="24" style="margin-top:15px;">
            <el-form-item label="评分">
              <el-rate v-model="data.Star" :max="3"></el-rate>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="text-align:right;margin-top:10px;">
      <el-button type="primary" @click="confirm">确 定</el-button>
      <el-button @click="close">取 消</el-button>
    </div>
  </common-dialog>
</template>
<script>
import commonDialog from "@/components/common/dialog";
import listDialogMixins from "@/mixins/listDialog";

export default {
  components: { commonDialog },
  mixins: [listDialogMixins],
  props: {
    title: {
      type: String,
      default: "选择星级",
    },
  },
  data() {
    return {
      api: require("@/api/analyse/follow").default,
      data: {
        FollowId: 0,
        StudentId: 0,
        ExamId: 0,
        AnalyseId: 0,
        AnalyseType: 0,
        StrongSubjects: "",
        StrongTeacherIds: "",
        StrongTeacherNames: "",
        WeakSubjects: "",
        WeakTeacherIds: "",
        WeakTeacherNames: "",
        Star: null,
      },
      classList: [],
      gradeList: []
    }
  },
  methods: {
    setData(row) {
      this.data.StudentId = row.StudentId;
      this.data.ExamId = row.ThisExamId;
      this.data.AnalyseId = row.AnalyseId;
      this.data.StrongSubjects = row.StrongSubjects;
      this.data.StrongTeacherIds = row.StrongTeacherIds;
      this.data.StrongTeacherNames = row.StrongTeacherNames;
      this.data.WeakSubjects = row.WeakSubjects;
      this.data.WeakTeacherIds = row.WeakTeacherIds;
      this.data.WeakTeacherNames = row.WeakTeacherNames
      this.data.AnalyseType = row.type;
    },
    confirm() {
      if(!this.data.Star) {
        this.$message.error("请先选择星级");
        return
      }
      this.loading(true);
      this.api.add(this.data).then(res => {
        this.loading(false);
        if(res.Code == 0) {
          this.$message.success("操作成功");
          this.$emit("confirm",this.data);
          this.data.Star = null;
          this.close();
        } else {
          this.$message.error(res.Msg);
        }
      })
    }
  },
};
</script>
<style lang="scss">
.el-rate{
  margin-top: 3px;
  .el-rate__icon{
    font-size: 24px;
  }
}
</style>